import { textColor } from './color';
export default {
  iconStyle: {
    normal: {
      borderColor: textColor.grayDark
    },
    emphasis: {
      borderColor: textColor.gray
    }
  }
};